import _ from "lodash";
import moment from "moment";
import { INSTANCE_URL, DATE_FORMAT, DEVELOPMENT_TYPE } from "Constants";
import { isEmpty } from "ActionsSpeakers";
import { updateEvent } from "ActionsMessage";
import { getRequest, postRequest, patchRequest } from "NetworkCall";
import { log } from "util";

export var SELECTING_FEATURE = "selecting_feature";
export var FETCH_SCHEDULE_DATE = "fetch_sechdule_date";
export var UPDATE_SCHEDULE_DATE = "update_schedule_date";
export var AVAILABLE_FEATURES = "available_features";
export var UPDATE_DATE_PROPS = "UPDATE_DATE_PROPS";
export var TOTAL_APP_MODULES = "TOTAL_APP_MODULES";
export var ACTION_APP_MODULES = "ACTION_APP_MODULES";
export var CONTENT_DASHBOARD_STATUS = "CONTENT_DASHBOARD_STATUS";
export var EDIT_SEO_CODE = "EDIT_SEO_CODE";
export var CONTENT_DISPLAY_ITEMS = "CONTENT_DISPLAY_ITEMS";
export var APP_MENU = "APP_MENU";
export var APP_BTM_MENU_FIXED = "APP_BTM_MENU_FIXED";
export var FIXED_FEATURES = "FIXED_FEATURES";

var availableFeatures = [
  {
    iconName: "Schedules",
    available: true,
    bsClass: "schedule",
    section: "content",
    description: "Schedule your event sessions.",
  },
  {
    iconName: "Speakers",
    available: true,
    bsClass: "speaker",
    section: "content",
    description: "A list of speakers at your event with their details.",
  },
  {
    iconName: "Exhibitors",
    available: true,
    bsClass: "exhibitor",
    section: "content",
    description: "List of event exhibitors with their details.",
  },
  {
    iconName: "Sponsors",
    available: true,
    bsClass: "sponsor",
    section: "content",
    description: "A list of your event sponsors.",
  },
  {
    iconName: "Messages",
    available: true,
    bsClass: "message",
    section: "content",
    description: "Allows users to chat directly with one another.",
  },
  {
    iconName: "Maps",
    available: true,
    bsClass: "maps",
    section: "content",
    description: "Map that displays your venue and event location.",
  },
  {
    iconName: "News",
    available: true,
    bsClass: "news",
    section: "content",
    description: "Display a list of news within your app.",
  },
  {
    iconName: "Social",
    available: true,
    bsClass: "social",
    section: "content",
    description: "Manage social options for your event.",
  },
  {
    iconName: "Event Guide",
    available: true,
    bsClass: "about",
    section: "content",
    description: "Display a general information about your event.",
  },
  {
    iconName: "Webview",
    available: true,
    bsClass: "webview",
    section: "content",
    description: "It displays a web page within your app.",
  },
  {
    iconName: "Gallery",
    available: true,
    bsClass: "gallery",
    section: "content",
    description: "Check your gallery.",
  },
  {
    iconName: "Survey",
    available: true,
    bsClass: "survey",
    section: "content",
    description: "Manage event survey.",
  },
  {
    iconName: "Attendees",
    available: true,
    bsClass: "attendee",
    section: "content",
    description: "Manage attendees.",
  },
  {
    iconName: "Community",
    available: true,
    bsClass: "community",
    section: "content",
    description: "Manage community.",
  },
];

if (DEVELOPMENT_TYPE === "koachify") {
  availableFeatures = [
    {
      iconName: "Live Classes",
      available: true,
      bsClass: "schedule",
      section: "content",
      description: "Schedule your Live classes.",
    },
    {
      iconName: "Instructors",
      available: true,
      bsClass: "speaker",
      section: "content",
      description: "A list of isntructors at your platform with their details.",
    },
    {
      iconName: "Messages",
      available: true,
      bsClass: "message",
      section: "content",
      description: "Allows users to chat directly with one another.",
    },
    {
      iconName: "News",
      available: true,
      bsClass: "news",
      section: "content",
      description: "Display a list of news within your app.",
    },
    {
      iconName: "Activity",
      available: true,
      bsClass: "social",
      section: "content",
      description: "Manage activities for your platform.",
    },
    {
      iconName: "Platform Guide",
      available: true,
      bsClass: "about",
      section: "content",
      description: "Display a general information about your platform.",
    },
    {
      iconName: "Webview",
      available: true,
      bsClass: "webview",
      section: "content",
      description: "It displays a web page within your app.",
    },
    {
      iconName: "Gallery",
      available: true,
      bsClass: "gallery",
      section: "content",
      description: "Check your gallery.",
    },
    {
      iconName: "Survey",
      available: true,
      bsClass: "survey",
      section: "content",
      description: "Manage event survey.",
    },
    {
      iconName: "Community",
      available: true,
      bsClass: "community",
      section: "content",
      description: "Manage community.",
    },
  ];
}

var availableModules = [
  {
    iconName: "General",
    alwaysavailable: true,
    isenabled: true,
    bsClass: "general",
    section: "module",
    description: "General information about your app and event.",
  },
  {
    iconName: "Features",
    alwaysavailable: true,
    isenabled: true,
    bsClass: "features",
    section: "module",
    description: "Add a new feature to your event app.",
  },
  {
    iconName: "Branding",
    alwaysavailable: true,
    isenabled: true,
    bsClass: "branding",
    section: "module",
    description:
      "Customize your app look and feel that matches with your brand.",
  },
  {
    iconName: "Contents",
    alwaysavailable: true,
    isenabled: true,
    bsClass: "content",
    section: "module",
    description: "Manage, add or remove your app contents.",
  },
  // {
  //   iconName: "Website",
  //   alwaysavailable: false,
  //   isenabled: true,
  //   bsClass: "website",
  //   section: "module",
  //   description: "Build your website on fly.",
  // },
  {
    iconName: "Tickets",
    alwaysavailable: false,
    isenabled: true,
    bsClass: "tickets",
    section: "module",
    description: "Manage tickets for the event.",
  },
  {
    iconName: "Users",
    alwaysavailable: false,
    isenabled: true,
    bsClass: "users",
    section: "module",
    description: "Manage and import users.",
  },
  {
    iconName: "Polls & Live QA",
    alwaysavailable: false,
    isenabled: true,
    bsClass: "polls",
    section: "content_module",
    description: "Manage Live QA and Polls.",
  },
  {
    iconName: "Outreach",
    alwaysavailable: false,
    isenabled: true,
    bsClass: "outreach",
    section: "module",
    description: "Broadcast message to users.",
  },
  {
    iconName: "Analytics",
    alwaysavailable: false,
    isenabled: true,
    bsClass: "analytics",
    section: "module",
    description: "View App analytics.",
  },
  {
    iconName: "Abstract Management",
    alwaysavailable: false,
    isenabled: false,
    bsClass: "proposal",
    section: "module",
    description: "Manage Abstracts/Proposal/Call",
  },
  {
    iconName: "Gamification",
    alwaysavailable: false,
    isenabled: false,
    bsClass: "gamification",
    section: "content_module",
    description: "Manage gamification.",
  },
  {
    iconName: "Help & Support",
    alwaysavailable: false,
    isenabled: true,
    bsClass: "support",
    section: "module",
    description: "Support to attendess.",
  },
  {
    iconName: "Event Settings",
    alwaysavailable: true,
    isenabled: true,
    bsClass: "settings",
    section: "module",
    description: "Manage event settings",
  }, // event settings added on the side menu om 28/9/22
  // {iconName:'Publish',alwaysavailable:true,isenabled:true,bsClass:'publish',section:'module',description:'A paid plan is required to publish this app.'},
];

if (DEVELOPMENT_TYPE === "koachify") {
  availableModules = [
    {
      iconName: "General",
      alwaysavailable: true,
      isenabled: true,
      bsClass: "general",
      section: "module",
      description: "General information about your app and platform.",
    },
    {
      iconName: "Features",
      alwaysavailable: true,
      isenabled: true,
      bsClass: "features",
      section: "module",
      description: "Add a new feature to your platform app.",
    },
    {
      iconName: "Branding",
      alwaysavailable: true,
      isenabled: true,
      bsClass: "branding",
      section: "module",
      description:
        "Customize your app look and feel that matches with your brand.",
    },
    {
      iconName: "Contents",
      alwaysavailable: true,
      isenabled: true,
      bsClass: "content",
      section: "module",
      description: "Manage, add or remove your app contents.",
    },
    {
      iconName: "Courses",
      alwaysavailable: false,
      isenabled: false,
      bsClass: "courses",
      section: "module",
      description: "Manage courses for the platform.",
    },
    // {
    //   iconName: "Website",
    //   alwaysavailable: false,
    //   isenabled: true,
    //   bsClass: "website",
    //   section: "module",
    //   description: "Build your website on fly.",
    // },
    {
      iconName: "Plans",
      alwaysavailable: false,
      isenabled: true,
      bsClass: "tickets",
      section: "module",
      description: "Manage Plans for the platform.",
    },
    {
      iconName: "Users",
      alwaysavailable: false,
      isenabled: true,
      bsClass: "users",
      section: "module",
      description: "Manage and import users.",
    },
    {
      iconName: "Polls & Live QA",
      alwaysavailable: false,
      isenabled: true,
      bsClass: "polls",
      section: "content_module",
      description: "Manage Live QA and Polls.",
    },
    {
      iconName: "Outreach",
      alwaysavailable: false,
      isenabled: true,
      bsClass: "outreach",
      section: "module",
      description: "Broadcast message to users.",
    },
    {
      iconName: "Analytics",
      alwaysavailable: false,
      isenabled: true,
      bsClass: "analytics",
      section: "module",
      description: "View App analytics.",
    },
  ];
}

const appBottomMenu = [
  {
    iconName: "Scanner",
    available: false,
    bsClass: "scanner",
    description: "Scan QR code",
  },
  {
    iconName: "Home",
    available: true,
    bsClass: "home",
    description: "Welcome to Home",
  },
];

const fixedAppBottomMenu = appBottomMenu.concat(availableFeatures);

const fixedFeatures =
  DEVELOPMENT_TYPE === "koachify"
    ? []
    : [
        {
          iconName: "Advertisements",
          available: true,
          bsClass: "advertisement",
          section: "content",
          isfixed: true,
          description: "Setup your advertisement.",
        },
      ];

export function fetchFeature(session, callback) {
  var features =
    DEVELOPMENT_TYPE === "koachify"
      ? {
          schedule: {
            label: "Live sessions",
            bsClass: "schedule",
            section: "content",
            description: "Schedule your live classes.",
          },
          speaker: {
            label: "Instructors",
            bsClass: "speaker",
            section: "content",
            description:
              "A list of isntructors at your platform with their details.",
          },
          message: {
            label: "Messages",
            bsClass: "message",
            section: "content",
            description: "Allows users to chat directly with one another.",
          },
          news: {
            label: "News",
            bsClass: "news",
            section: "content",
            description: "Display a list of news within your app.",
          },
          social: {
            label: "Activity",
            bsClass: "social",
            section: "content",
            description: "Manage activities for your platform.",
          },
          about: {
            label: "Platform Guide",
            bsClass: "about",
            section: "content",
            description: "Display a general information about your platform.",
          },
          webview: {
            label: "Webview",
            bsClass: "webview",
            section: "content",
            description: "It displays a web page within your app.",
          },
          gallery: {
            label: "Gallery",
            bsClass: "gallery",
            section: "content",
            description: "Check your gallery.",
          },
          survey: {
            label: "Survey",
            bsClass: "survey",
            section: "content",
            description: "Manage event survey.",
          },
          community: {
            label: "Community",
            bsClass: "community",
            section: "content",
            description: "Manage community.",
          },
        }
      : {
          schedule: {
            label: "Schedule",
            bsClass: "schedule",
            section: "content",
            description: "Schedule your event sessions.",
          },
          speaker: {
            label: "Speaker",
            bsClass: "speaker",
            section: "content",
            description: "A list of speakers at your event with their details.",
          },
          exhibitors: {
            label: "Exhibitors",
            bsClass: "exhibitor",
            section: "content",
            description: "List of event exhibitors with their details.",
          },
          sponsors: {
            label: "Sponsors",
            bsClass: "sponsor",
            section: "content",
            description: "A list of your event sponsors.",
          },
          message: {
            label: "Messages",
            bsClass: "message",
            section: "content",
            description: "Allows users to chat directly with one another.",
          },
          maps: {
            label: "Maps",
            bsClass: "maps",
            section: "content",
            description: "Map that displays your venue and event location.",
          },
          news: {
            label: "News",
            bsClass: "news",
            section: "content",
            description: "Display a list of news within your app.",
          },
          social: {
            label: "Social",
            bsClass: "social",
            section: "content",
            description: "Manage social options for your event.",
          },
          about: {
            label: "Event Guide",
            bsClass: "about",
            section: "content",
            description: "Display a general information about your event.",
          },
          webview: {
            label: "Webview",
            bsClass: "webview",
            section: "content",
            description: "It displays a web page within your app.",
          },
          gallery: {
            label: "Gallery",
            bsClass: "gallery",
            section: "content",
            description: "Check your gallery.",
          },
          survey: {
            label: "Survey",
            bsClass: "survey",
            section: "content",
            description: "Manage event survey.",
          },
          attendee: {
            label: "Attendees",
            bsClass: "attendee",
            section: "content",
            description: "Manage attendees.",
          },
          community: {
            label: "Community",
            bsClass: "community",
            section: "content",
            description: "Manage community.",
          },
        };

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/apptabs?filter=eventid=${session.eventid}&order=taborder%20ASC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        // debugger;

        // Content work.....
        var items = [];
        // var cloneItems = [];
        // var temp_items = [];
        if (!isEmpty(data.resource)) {
          _.map(features, function (feature) {
            var match = _.filter(data.resource, {
              tabslected: feature.bsClass,
            });

            // debugger;

            if (match && match.length > 0) {
              var obj = feature;
              obj.apptabid = match[0].apptabid;
              obj.taborder = match[0].taborder;
              obj.isenabled = match[0].isenabled;
              obj.displayname = match[0].displaytabname;
              items.push(obj);
            }
          });
        }
        // cloneItems = [...items];

        // _.map(items, (item) => {
        //   temp_items = _.concat(temp_items, item);
        // });

        // debugger;

        var arrAvailable = [];
        _.map(availableFeatures, function (feature) {
          var match = _.filter(items, { bsClass: feature.bsClass });
          if (match && match.length > 0) {
            var obj = feature;
            obj.apptabid = match[0].apptabid;
            obj.taborder = match[0].taborder;
            obj.isenabled = match[0].isenabled;
            obj.displayname = match[0].displayname;
            obj.available = true;
            arrAvailable.push(obj);
          }
        });
        var sortArrAvailable = _.sortBy(arrAvailable, "taborder", "asc");

        // Module work.....
        var moduleItems = [];
        if (!isEmpty(data.resource)) {
          _.map(availableModules, function (modules) {
            var match = _.filter(data.resource, {
              tabslected: modules.bsClass,
            });

            // console.log('match',match)
            if (match && match.length > 0) {
              var obj = match[0];
              modules.apptabid = obj.apptabid;
              modules.taborder = obj.taborder;
              modules.isenabled = obj.isenabled;
              modules.displayname = obj.displaytabname;
              moduleItems.push(modules);
            } else {
              moduleItems.push(modules);
            }
          });
        }
        // console.log('moduleItems',moduleItems)

        var actionModules = _.filter(JSON.parse(JSON.stringify(moduleItems)), {
          alwaysavailable: false,
        });

        // Added only for shorting featurn of content sub menu {as we have to section to display in content meny, adding poll here }
        var dispalyModelInContent = _.filter(
          JSON.parse(JSON.stringify(actionModules)),
          (obj) => {
            return (
              obj.taborder !== 99 &&
              obj.bsClass != "polls" &&
              obj.bsClass == "gamification"
            ); // Now poll will not display under content section and btm-menu
          }
        );
        var mergeArray = arrAvailable.concat(dispalyModelInContent);
        var sortMergeArray = _.sortBy(mergeArray, "taborder", "asc");

        // App Bottom Menu
        var arrAppBtmMenu = [];
        if (!isEmpty(data.resource)) {
          var btmAppMenuArr = _.filter(data.resource, (obj) => {
            return obj.taborder > 100;
          });
          var contentMenuArr = JSON.parse(JSON.stringify(sortMergeArray));

          _.map(btmAppMenuArr, (menu) => {
            var match = [];
            if (menu.tabslected === "btm-polls") {
              match = _.filter(contentMenuArr, (obj) => {
                return menu.tabslected == `btm-${obj.bsClass}`;
              });
            } else if (menu.tabslected === "btm-gamification") {
              match = _.filter(contentMenuArr, (obj) => {
                return menu.tabslected == `btm-${obj.bsClass}`;
              });
            } else {
              match = _.filter(fixedAppBottomMenu, (obj) => {
                return menu.tabslected == `btm-${obj.bsClass}`;
              });
            }

            if (match && match.length > 0) {
              var obj = menu;
              obj.iconName = match[0].iconName;
              obj.bsClass = match[0].bsClass;
              obj.description = match[0].description;

              // delete not required key values
              delete obj["createdby"];
              delete obj["updatedby"];
              delete obj["createdon"];
              delete obj["updatedon"];
              delete obj["iconimagepath"];
              // delete obj["displaytabname"];
              // delete obj["tabslected"];
              delete obj["eventid"];

              arrAppBtmMenu.push(obj);
            }
          });
          var sortArrAppBtmMenu = _.sortBy(arrAppBtmMenu, "taborder", "asc");
        }

        dispatch({ type: SELECTING_FEATURE, payload: items });
        dispatch({ type: AVAILABLE_FEATURES, payload: sortArrAvailable });
        dispatch({ type: TOTAL_APP_MODULES, payload: moduleItems });
        dispatch({ type: ACTION_APP_MODULES, payload: actionModules });
        dispatch({ type: CONTENT_DISPLAY_ITEMS, payload: sortMergeArray });
        dispatch({ type: APP_MENU, payload: sortArrAppBtmMenu });
        dispatch({
          type: APP_BTM_MENU_FIXED,
          payload: JSON.parse(JSON.stringify(sortArrAppBtmMenu)),
        });
        dispatch({ type: FIXED_FEATURES, payload: fixedFeatures });

        if (callback !== undefined) {
          callback({});
        }
      },
      (error) => {}
    );
  };
}

export function updateBottomMenuLocally(btmmenu) {
  return { type: APP_MENU, payload: btmmenu };
}

export function updateAppSideMenuLocally(appmenu) {
  return { type: CONTENT_DISPLAY_ITEMS, payload: appmenu };
}

export function updateSortedFeatures(arrAvailable, session) {
  /**
   * storing the availableFeatures list as we are doing in fetchFeature method,
   * its required, coz when we r removing any option from list from the content selection option, availableFeatures is updated to list after removed one
   * but we need to show all features list
   */
  var arrAvailableArray = [];
  _.map(availableFeatures, function (feature) {
    var available = false;
    var apptabid = "";
    var taborder = "";
    _.map(arrAvailable, function (item) {
      if (item.bsClass === feature.bsClass) {
        available = true;
        apptabid = item.apptabid;
        taborder = item.taborder;
      }
    });
    var newfeature = { ...feature, available, apptabid, taborder };
    arrAvailableArray.push(newfeature);
  });
  var sortArrAvailable = _.sortBy(arrAvailableArray, "taborder", "asc");

  return (dispatch) => {
    //dispatch it immeditely don't wait for server response
    dispatch({ type: AVAILABLE_FEATURES, payload: sortArrAvailable });
    dispatch({ type: CONTENT_DISPLAY_ITEMS, payload: arrAvailable });

    var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
    var postData = { features: arrAvailable, type: "updateAppTabs" };

    postRequest(
      url,
      postData,
      session,
      dispatch,
      (result) => {
        //No need to show alert on success or, error, even we don't need to fetchfeature as dispatched array above is same as of server
      },
      (error) => {
        //No need to handle error
      }
    );
  };
}

export function updateSelectedFeature(selectedFeatures, currentFeature) {
  var opArray = selectedFeatures.slice();
  var index = _.findIndex(opArray, { bsClass: currentFeature.bsClass });
  opArray.splice(index, 1, currentFeature);

  return (dispatch) => {
    dispatch({ type: SELECTING_FEATURE, payload: opArray });
  };

  // var updatedFeatures;

  // var featureAlreadySelected=features.filter((feature) => feature === selectedFeature)[0];

  // if(featureAlreadySelected){
  //   features = _.reject(features,featureAlreadySelected);
  //   updatedFeatures = [...features];
  // }else {
  //   updatedFeatures=[...features,selectedFeature];
  // }

  // return {
  //   type: SELECTING_FEATURE,
  //   payload: updatedFeatures
  // }
}
export function updateAdvertisement(session, internalscreen, isenabled) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (internalscreen=${internalscreen})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/advertisement?filter=(${filter})`;
  var eventid = session.eventid;
  var data = { resource: { isenabled: isenabled, eventid } };
  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        // dispatch(fetchEvent(session));
        // old codds successCallback({ error: 0, data: data });
      },
      (error) => {
        // errorCallback({ error: 1, data: error });
      }
    );
  };
}

export function updateSelectedModule(actionAppModules, currentModule) {
  var opArray = actionAppModules.slice();
  var index = _.findIndex(opArray, { bsClass: currentModule.bsClass });
  // opArray.splice(index, 1, currentModule);
  opArray[index].isenabled = currentModule.isenabled;

  return (dispatch) => {
    dispatch({ type: ACTION_APP_MODULES, payload: opArray });
  };
}

export function fetchScheduleDates(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/scheduledates?filter=%28eventid=${session.eventid}%29AND%28isactive=1%29&order=scheduledate%20ASC`;
  var returnData;
  /*
  startDate: moment(_.first(data.resource).scheduledate),
  endDate:moment(_.last(data.resource).scheduledate),
  */
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        if (!isEmpty(data.resource)) {
          returnData = {
            allDate: data.resource,
          };
        } else {
          returnData = {};
        }
        dispatch({ type: FETCH_SCHEDULE_DATE, payload: returnData });
        dispatch({ type: UPDATE_SCHEDULE_DATE, payload: data.resource });
      },
      (error) => {}
    );
  };
}

export function dateRangeUpdate(object) {
  var startDate = moment(object.startDate);
  var endDate = moment(object.endDate);
  var allDate = [];
  var day = {};
  var n = endDate.diff(startDate, "days") + 1;
  for (var i = 1; i <= n; i++) {
    if (i !== 1) {
      day = moment(day).add(1, "days");
    } else {
      day = startDate;
    }
    allDate.push({ scheduledate: moment(day).format(DATE_FORMAT) });
  }
  object = { ...object, allDate };
  return (dispatch) => {
    dispatch({ type: FETCH_SCHEDULE_DATE, payload: object });
    dispatch({ type: UPDATE_SCHEDULE_DATE, payload: allDate });
  };
}

export function updateDateSelect(allDate, currentObj) {
  var newObj;
  var activeDate = _.find(allDate, {
    scheduledate: moment(currentObj).format(DATE_FORMAT),
  });
  if (activeDate === undefined) {
    //allDate.push({scheduledate: moment(currentObj).format('YYYY-MM-DD')});
    newObj = [
      ...allDate,
      { scheduledate: moment(currentObj).format(DATE_FORMAT) },
    ];
  } else {
    if (allDate.length > 1) {
      // atleast 1 date should be selected
      allDate = _.reject(allDate, activeDate);
    }
    newObj = [...allDate];
  }

  return (dispatch) => {
    dispatch({ type: UPDATE_SCHEDULE_DATE, payload: newObj });
  };
}
/*
Execute network call handler for features, scheduledate and event name
*/
export function patchEventDetails(
  session,
  request,
  successCallback,
  errorCallback
) {
  return (dispatch) => {
    dispatch(updateEvent(session, request, successCallback, errorCallback));

    if (request.allDate && request.allDate.length > 0) {
      dispatch(
        patchScheduleDates(session, request, successCallback, errorCallback)
      );
    }

    //dispatch(patchFeatures(session, request, successCallback, errorCallback));
    // dispatch(patchFeatures(session, request, (response) => {
    //   updateEvent(session,{eventname:request.eventname},(response) => {
    //     if (response.error == 0) {
    //       patchScheduleDates(session, request, (result) => {
    //         successCallback("success")
    //       }, (error) => {
    //         errorCallback(response.data);
    //       });
    //     } else {
    //       errorCallback(response.data);
    //     }
    //   })
    // }, (error) => {
    //   errorCallback(error);
    // }));
    //
    // //BOC Update features.
    // dispatch(patchFeatures(session,request,(result) =>{
    //
    //   dispatch(successCallback(result));
    // },(error) => {
    //   dispatch(errorCallback(error));
    // }));
    // //EOC Update features.
    // //BOC Update event name.
    // dispatch(updateEvent(session,{eventname:request.eventname},(result) =>{
    // }));
    // //EOD Update event name.
    // //BOD Update Schedule dates.
    // dispatch(patchScheduleDates(session,request,(result) =>{
    //   dispatch(successCallback(result));
    // },(error) => {
    //   dispatch(errorCallback(error));
    // }));
    // //EOD Update Schedule dates.
  };
}
/*
Update features network call handle.
*/
export function patchFeatures(
  session,
  request,
  update = false,
  successCallback,
  errorCallback
) {
  var postData = {};
  var { eventid } = session;
  var features = request.newFeatures;
  var bottomMenu =
    request.bottomMenu && request.bottomMenu.length > 0
      ? request.bottomMenu
      : []; // sending only from features update page, so added this condtion
  postData = { ...postData, eventid };
  postData = { ...postData, features, bottomMenu };

  if (!isEmpty(features)) {
    return (dispatch) => {
      //var url = `${INSTANCE_URL}/api/v2/eventifyscript/updateFeatures`;
      var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=updateFeaturesTabs`;
      postRequest(
        url,
        postData,
        session,
        dispatch,
        (result) => {
          /*if (update) {
          dispatch(fetchFeature(session));
        }*/
          successCallback(result);
        },
        (error) => {
          errorCallback(error);
        }
      );
    };
  }
}
/*
Update Schedules date network call handle.
*/
function patchScheduleDates(session, request, successCallback, errorCallback) {
  //debugger;
  var postData = {};
  var { eventid } = session;
  var scheduleDates = request.allDate;
  postData = { ...postData, eventid };
  postData = { ...postData, scheduleDates };
  return (dispatch) => {
    var url = `${INSTANCE_URL}/api/v2/eventifyscript/updateScheduleDates`;
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (result) => {
        successCallback(result);
      },
      (error) => {
        errorCallback(error);
      }
    );
  };
}

export function updateDateProps(values) {
  return (dispatch) => {
    dispatch({ type: UPDATE_DATE_PROPS, payload: values });
  };
}

export function checkContentDashboardStatus(session) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=contentDashboardStatus&eventid=${session.eventid}&developmenttype=${DEVELOPMENT_TYPE}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: CONTENT_DASHBOARD_STATUS,
          payload: { data: response },
        });
      },
      (error) => {}
    );
  };
}

export function toggleEditSEOCodeEditor(show) {
  return {
    type: EDIT_SEO_CODE,
    payload: show,
  };
}

export function validateSEOCode(session, seocode, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?filter=(seocode=${seocode})`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        if (data.resource.length > 0) {
          callback({ success: 2, message: "Seo is not available!" });
        } else {
          callback({ success: 1, message: "Seo is available!" });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateSEOCode(session, values, eventid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event/${eventid}`;
  return (dispatch) => {
    patchRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        // dispatch(fetchUserList(session));
        callback({ success: 1 });
      },
      (error) => {
        if (error.code == 23000) {
          callback({ success: 2, message: error });
        } else {
          callback({ success: 0, message: error });
        }
      }
    );
  };
}

export function resetAppmodules() {
  let moduleItems = [];
  return (dispatch) => {
    dispatch({ type: TOTAL_APP_MODULES, payload: moduleItems });
  };
}
